export const conversationAIRouteNames = {
  aiEmployeePromoLocation: 'ai-employee-promo-location',
  conversationAISettings: 'conversation-ai-settings',
  conversationAISettingsV2: 'conversation-ai-settings-v2',
  conversationAISettingsV2Default: "conversation-ai-settings-v2-default",
  conversationAISettingsV2CreateAgent: 'conversation-ai-settings-v2-create-agent',
  conversationAISettingsV2CreateAgentFmb: 'conversation-ai-settings-v2-create-agent-fmb',
  conversationAISettingsV2EditAgent: 'conversation-ai-settings-v2-edit-agent',
  conversationAISettingsV2EditAgentFmb: 'conversation-ai-settings-v2-edit-agent-fmb',
  aiAgentsGettingStarted: 'ai-agents-getting-started',
  aiAgentsVoiceAi: 'ai-agents-voice-ai',
  aiAgentsConversationAi: 'ai-agents-conversation-ai',
  aiAgentsContentAi: 'ai-agents-content-ai',
}
